export type AssetTypeRateValue = {
  Cat: string,
  Type: string,
  Rate: number,
}[] | null;

